export default __webpack_public_path__ + "static/media/chairs-2.2f0af227.png";